import { flow, get } from 'lodash/fp';

export const getAdmin = get('admin');
export const isLoadingUserReport = flow(getAdmin, get('isLoadingUserReport'));
